module.exports = __webpack_public_path__ + "img/123chat.4c787f66.jpg";